import PropTypes from 'prop-types';

export const PhoneNumberPropType = PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    countryCode: PropTypes.string,
    prefix: PropTypes.string,
    number: PropTypes.string,
});
